import React from 'react';
import {useTranslation} from 'react-i18next';
import LightGreenButton from '../../../../../Components/Buttons/LightGreenButton';
import styles from './HistoryButtons.module.css';

interface HistoryButtonsProps {
	showOrdersTable: boolean;
	showActivitiesTable: boolean;
	onToggleOrders: () => void;
	onToggleActivities: () => void;
}

const HistoryButtons: React.FC<HistoryButtonsProps> = ({
	showOrdersTable,
	showActivitiesTable,
	onToggleOrders,
	onToggleActivities,
}) => {
	const {t} = useTranslation();

	return (
		<div className={styles.historyButtonsContainer}>
			<LightGreenButton
				text={showOrdersTable ? t('Сховати історію') : t('Історія замовлень')}
				type="button"
				onClick={onToggleOrders}
				className={styles.historyButton}
			/>
			<LightGreenButton
				text={
					showActivitiesTable ? t('Сховати історію') : t('Історія активностей')
				}
				type="button"
				onClick={onToggleActivities}
				className={styles.historyButton}
			/>
		</div>
	);
};

export default HistoryButtons;
